<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{item.ct_result}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商编号</label>
            <span class="weui-form-preview__value">{{item.agentcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">代理商名称</label>
            <span class="weui-form-preview__value">{{item.agentname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">报备日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.ct_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{item.ct_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行业类型</label>
            <span class="weui-form-preview__value">{{item.ct_industry}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核状态</label>
            <span class="weui-form-preview__value">{{item.ct_status}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">创建时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.createTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!item.ct_result">
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="confirm">
        同意
      </div>
      <div class="weui-dialog__btn weui-dialog__btn_primary" @click="refuse">
        拒绝
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var item = this.$route.params.item
    return {
      item,
    }
  },
  methods: {
    confirm() {
      var me = this
      me.$loading({
        url: '/api/agent/clientput/confirm/' + me.item.id,
        method: "POST"
      }).then(function(res){
          if (res.success) {
            me.$weui.toast("已同意", 2000);
          }
      }).catch(function(err) {
          me.$weui.topTips(err, 3000);
      });
    },
    refuse() {
      var me = this
      me.$loading({
        url: '/api/agent/clientput/refuse/' + me.item.id,
        method: "POST"
      }).then(function(res){
          if (res.success) {
            me.$weui.toast("已拒绝", 2000);
          }
      }).catch(function(err) {
          me.$weui.topTips(err, 3000);
      });
    }
  }
}
</script>